import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Button, colors } from '@material-ui/core'
import { Page, Header } from 'components'
import clsx from 'clsx'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import useRouter from 'utils/useRouter'
import { useRegionalService } from 'hooks/useRegionalService'
import { Formulario } from './components'
import { useAuth } from 'hooks/useAuth'
import constants from 'utils/constants'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3, 3, 6, 3),
  },
  aboutAuthor: {
    marginTop: theme.spacing(3),
  },
  aboutProject: {
    marginTop: theme.spacing(3),
  },
  projectCover: {
    marginTop: theme.spacing(3),
  },
  projectDetails: {
    marginTop: theme.spacing(3),
  },
  preferences: {
    marginTop: theme.spacing(3),
  },
  actions: {
    marginTop: theme.spacing(3),
  },
  deleteButton: {
    marginLeft: 10,
    background: `linear-gradient(45deg, ${colors.red[900]} 30%, ${colors.red[800]} 90%)`,
    color: 'white',
  },
}))

export const EditarRegional = (props) => {
  const { route } = props
  const router = useRouter()
  const regionalService = useRegionalService()
  const dispatch = useDispatch()
  const classes = useStyles()
  const [dados, setDados] = useState({})

  const idsState = useSelector((state) => state.idsState)
  const [openAlertDelete, setOpenAlertDelete] = useState(false)
  const { permissoesUsuario, verificarPermissao } = useAuth()

  useEffect(() => {

    if (permissoesUsuario?.length) {
      if(!verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA])) {
        router.history.push(`/`)
      }
    }
  }, [permissoesUsuario])

  const handleClickOpenAlertDelete = () => {
    setOpenAlertDelete(true)
  }

  const handleCloseAlertDelete = () => {
    setOpenAlertDelete(false)
  }

  useEffect(() => {
    const fetchDados = async () => {
      const reg = await regionalService.listarRegionalAsync(idsState.idRegional)
      if (reg) {
        const regional = {
          id: reg.id,
          nome: reg.nome,
          sigla: reg.sigla,
          descricao: reg.descricao,
          orgao: reg.orgao.id,
        }
        setDados(regional)
      }
    }

    if (route.editar) {
      fetchDados()
    }
    
  }, [dispatch, idsState.idRegional, route.editar, router])

  const handleDelete = async (event) => {
    event.preventDefault()
    await regionalService.deletarRegional(dados.id)
    await regionalService.listarRegionaisDeOrgaoGlobal(idsState.idOrgao)
    router.history.push('/orgaos/regionais')
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} idPai={idsState.idOrgao} />
      <Formulario
        editar={route.editar}
        dados={dados}
        className={classes.aboutProject}
        idPai={idsState.idOrgao}
      />
      <div className={classes.actions}>
        {!route.editar ? (
          <Button form="form-edit-regional" type="submit" color="secondary" variant="contained" style={{ float: 'right' }}>
            Cadastrar regional
          </Button>
        ) : (
          <div>
            <Button
              form="form-edit-regional"
              type="submit"
              color="secondary"
              variant="contained"
              style={{ float: 'right' }}
            >
              Atualizar
            </Button>
            <Button
              onClick={handleClickOpenAlertDelete}
              variant="contained"
              className={clsx(classes.deleteButton)}
            >
              Excluir
            </Button>
          </div>
        )}
      </div>
      <Dialog
        open={openAlertDelete}
        onClose={handleCloseAlertDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Tem certeza que deseja deletar?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dados.nome} não poderá mais ser acessado.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlertDelete} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleDelete} className={clsx(classes.deleteButton)} autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  )
}
